import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NewsCategory } from 'src/app/source/features/noticias/interfaces/noticias-data.interface';

@Component({
  selector: 'app-categories-selection',
  templateUrl: './categories-selection.component.html',
  styleUrls: ['./categories-selection.component.scss']
})
export class CategoriesSelectionComponent {
  @Input() categories: NewsCategory[] = [];
  @Output() categoryChanged = new EventEmitter<string>();

  public categorySelected: string = 'todas';

  selectCategory(slug: string) {
    this.categorySelected = slug;
    this.categoryChanged.emit(slug);
  }
}

